import styled from "styled-components";

import { ReactComponent as EyeNotAllowed } from "../../../../../assets/eye-not-allowed.svg";

export const Wrapper = styled.div`
  position: relative;
  margin-left: -20px;
  margin-right: -20px;
`;

export const Content = styled.div`
  filter: blur(4px);
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  padding: 60px 0 53px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  box-sizing: border-box;
`;

export const Title = styled.p`
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 20px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  width: 487px;
  max-width: 100%;
  & + & {
    margin-top: 5px;
  }
`;

export const EyeNotAllowedIcon = styled(EyeNotAllowed)`
  margin-bottom: 22px;
  width: 46px;
  height: 40px;
  box-sizing: content-box;
`;
